import { createVNode as _createVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-3" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "login-header d-block mb-3" }, [
  /*#__PURE__*/_createVNode("h1", null, "Signup to create an account"),
  /*#__PURE__*/_createVNode("p", { class: "text-muted" }, "Enter your personal details to create account")
], -1)
const _hoisted_3 = { class: "form-wrap" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-6" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = /*#__PURE__*/_createVNode("label", { for: "fname" }, "First Name:", -1)
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", { for: "fname" }, "Last Name:", -1)
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = /*#__PURE__*/_createVNode("label", { for: "fname" }, "Email/Phone:", -1)
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "input-with-icon" }
const _hoisted_15 = {
  key: 0,
  class: "input-icon"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("i", { class: "fa fa-pencil-alt" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Change ")
const _hoisted_18 = {
  key: 0,
  class: "verified text-green fs-5 mt-2"
}
const _hoisted_19 = /*#__PURE__*/_createVNode("i", { class: "fa fa-check-circle fa-2x" }, null, -1)
const _hoisted_20 = {
  key: 0,
  class: "alert alert-danger mt-2"
}
const _hoisted_21 = {
  role: "alert",
  "aria-live": "assertive"
}
const _hoisted_22 = {
  key: 0,
  class: "form-group"
}
const _hoisted_23 = /*#__PURE__*/_createVNode("label", { for: "" }, "Enter OTP", -1)
const _hoisted_24 = { class: "d-flex align-items-center" }
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "flex-shrink-0 mr-2" }, null, -1)
const _hoisted_26 = { class: "flex-grow-1" }
const _hoisted_27 = { class: "d-flex align-items-center" }
const _hoisted_28 = { class: "flex-grow-1 mr-2" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-8" }
const _hoisted_31 = { class: "col-4" }
const _hoisted_32 = {
  key: 1,
  class: "form-group"
}
const _hoisted_33 = { class: "alert alert-warning text-center" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = /*#__PURE__*/_createVNode("i", { class: "fa fa-info-circle" }, null, -1)
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" The Pass Code has been sent to your phone number ")
const _hoisted_37 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_38 = { key: 1 }
const _hoisted_39 = /*#__PURE__*/_createVNode("i", { class: "fa fa-info-circle" }, null, -1)
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" The Pass Code has been sent to your email address ")
const _hoisted_41 = /*#__PURE__*/_createTextVNode(".")
const _hoisted_42 = {
  key: 0,
  class: "text-center"
}
const _hoisted_43 = { class: "my-4" }
const _hoisted_44 = /*#__PURE__*/_createTextVNode("Didn't get code? ")
const _hoisted_45 = /*#__PURE__*/_createVNode("strong", null, "Resend Again", -1)
const _hoisted_46 = {
  key: 2,
  class: "border rounded p-3 mb-3 bg-light"
}
const _hoisted_47 = { class: "form-group" }
const _hoisted_48 = /*#__PURE__*/_createVNode("label", { for: "" }, "Notification:", -1)
const _hoisted_49 = { class: "row" }
const _hoisted_50 = { class: "col-md-6" }
const _hoisted_51 = { class: "form-check" }
const _hoisted_52 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "flexCheckDefault"
}, " Notify By Text ", -1)
const _hoisted_53 = { class: "col-md-6" }
const _hoisted_54 = { class: "form-check" }
const _hoisted_55 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "flexCheckDefault1"
}, " Notify By Email ", -1)
const _hoisted_56 = {
  key: 3,
  class: "form-group"
}
const _hoisted_57 = { for: "fname" }
const _hoisted_58 = { class: "row" }
const _hoisted_59 = { class: "input-with-icon" }
const _hoisted_60 = {
  key: 2,
  class: "input-icon"
}
const _hoisted_61 = /*#__PURE__*/_createVNode("i", { class: "fa fa-pencil-alt" }, null, -1)
const _hoisted_62 = {
  key: 0,
  class: "verified text-green fs-5 mt-2"
}
const _hoisted_63 = /*#__PURE__*/_createVNode("i", { class: "fa fa-check-circle fa-2x" }, null, -1)
const _hoisted_64 = {
  key: 0,
  class: "alert alert-danger mt-2"
}
const _hoisted_65 = {
  role: "alert",
  "aria-live": "assertive"
}
const _hoisted_66 = {
  key: 4,
  class: "form-group"
}
const _hoisted_67 = /*#__PURE__*/_createVNode("label", { for: "" }, "Enter OTP", -1)
const _hoisted_68 = { class: "d-flex align-items-center" }
const _hoisted_69 = /*#__PURE__*/_createVNode("div", { class: "flex-shrink-0 mr-2" }, null, -1)
const _hoisted_70 = { class: "flex-grow-1" }
const _hoisted_71 = { class: "d-flex align-items-center" }
const _hoisted_72 = { class: "flex-grow-1 mr-2" }
const _hoisted_73 = { class: "row" }
const _hoisted_74 = { class: "col-8" }
const _hoisted_75 = { class: "col-4" }
const _hoisted_76 = {
  key: 5,
  class: "form-group"
}
const _hoisted_77 = { class: "alert alert-warning text-center" }
const _hoisted_78 = { key: 0 }
const _hoisted_79 = /*#__PURE__*/_createVNode("i", { class: "fa fa-info-circle" }, null, -1)
const _hoisted_80 = /*#__PURE__*/_createTextVNode(" The Pass Code has been sent to your phone number ")
const _hoisted_81 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_82 = { key: 1 }
const _hoisted_83 = /*#__PURE__*/_createVNode("i", { class: "fa fa-info-circle" }, null, -1)
const _hoisted_84 = /*#__PURE__*/_createTextVNode(" The Pass Code has been sent to your email address ")
const _hoisted_85 = /*#__PURE__*/_createTextVNode(".")
const _hoisted_86 = {
  key: 0,
  class: "text-center"
}
const _hoisted_87 = { class: "my-4" }
const _hoisted_88 = /*#__PURE__*/_createTextVNode("Didn't get code? ")
const _hoisted_89 = /*#__PURE__*/_createVNode("strong", null, "Resend Again", -1)
const _hoisted_90 = { class: "btn-wrap mb-5 pt-0" }
const _hoisted_91 = { class: "modal-wrap default-modal success-modal" }
const _hoisted_92 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "registerSuccessModal",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_93 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_94 = { class: "modal-content" }
const _hoisted_95 = { class: "msg-header text-center" }
const _hoisted_96 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_97 = /*#__PURE__*/_createVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    class: "bi bi-check-circle",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      d: "M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z"
    })
  ])
], -1)
const _hoisted_98 = { class: "modal-body text-center" }
const _hoisted_99 = { class: "success-body mb-2" }
const _hoisted_100 = /*#__PURE__*/_createVNode("div", { class: "msg-body" }, [
  /*#__PURE__*/_createVNode("h3", null, "Successful!"),
  /*#__PURE__*/_createVNode("h5", null, "Account successfully created")
], -1)
const _hoisted_101 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_AppEmailAndPhoneNumberValidate = _resolveComponent("AppEmailAndPhoneNumberValidate")
  const _component_AppOTPInput = _resolveComponent("AppOTPInput")
  const _component_CounterComponent = _resolveComponent("CounterComponent")
  const _component_AppEmailInput = _resolveComponent("AppEmailInput")
  const _component_AppPhoneNumberInput = _resolveComponent("AppPhoneNumberInput")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_ErrorList, {
          errors: _ctx.state.ui.error.validationList,
          hasError: _ctx.state.ui.error.hasError
        }, null, 8, ["errors", "hasError"]),
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _hoisted_7,
              _withDirectives(_createVNode("input", {
                type: "text",
                id: "username",
                name: "username",
                class: "form-control",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.data.registration.firstName = $event))
              }, null, 512), [
                [_vModelText, _ctx.state.data.registration.firstName]
              ])
            ])
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _hoisted_10,
              _withDirectives(_createVNode("input", {
                type: "text",
                id: "username",
                name: "username",
                class: "form-control",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.data.registration.lastName = $event))
              }, null, 512), [
                [_vModelText, _ctx.state.data.registration.lastName]
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_11, [
          _hoisted_12,
          _createVNode("div", _hoisted_13, [
            _createVNode("div", {
              class: _ctx.state.ui.showUI.primaryInputClass
            }, [
              _createVNode("div", _hoisted_14, [
                _createVNode(_component_AppEmailAndPhoneNumberValidate, {
                  onUpdateInput: _ctx.handleInput,
                  onEmitError: _ctx.handleError,
                  disabled: _ctx.state.ui.disabled.primary,
                  onClearInput: _ctx.handleClear,
                  onValidationResult: _ctx.handleValidationResult
                }, null, 8, ["onUpdateInput", "onEmitError", "disabled", "onClearInput", "onValidationResult"]),
                (_ctx.state.ui.showUI.changePrimaryInput)
                  ? (_openBlock(), _createBlock("div", _hoisted_15, [
                      _createVNode("a", {
                        title: "edit",
                        href: "javascript:void(0)",
                        class: "change-text",
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.dataClear && _ctx.dataClear(...args)))
                      }, [
                        _hoisted_16,
                        _hoisted_17
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 2),
            (!_ctx.state.ui.showUI.primaryOTPSent)
              ? (_openBlock(), _createBlock("div", {
                  key: 0,
                  class: _ctx.state.ui.showUI.primaryIconClass
                }, [
                  (_ctx.state.ui.showUI.primaryVerified)
                    ? (_openBlock(), _createBlock("div", _hoisted_18, [
                        _hoisted_19
                      ]))
                    : (_openBlock(), _createBlock("button", {
                        key: 1,
                        class: "btn default-btn w-100 h-100",
                        disabled: (!_ctx.buttonhasValidPrimaryInput) || (_ctx.state.ui.showUI.primaryVerified),
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.verifyPrimary && _ctx.verifyPrimary(...args)))
                      }, _toDisplayString(_ctx.$t('verify')), 9, ["disabled"]))
                ], 2))
              : _createCommentVNode("", true)
          ]),
          (_ctx.errorMessage)
            ? (_openBlock(), _createBlock("div", _hoisted_20, [
                _createVNode("p", _hoisted_21, _toDisplayString(_ctx.errorMessage), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.state.ui.showUI.showOTP)
          ? (_openBlock(), _createBlock("div", _hoisted_22, [
              _hoisted_23,
              _createVNode("div", _hoisted_24, [
                _hoisted_25,
                _createVNode("div", _hoisted_26, [
                  _createVNode("div", _hoisted_27, [
                    _createVNode("div", _hoisted_28, [
                      _createVNode("div", _hoisted_29, [
                        _createVNode("div", _hoisted_30, [
                          _createVNode(_component_AppOTPInput, { onSixDigitInput: _ctx.handleSixDigitOTP }, null, 8, ["onSixDigitInput"])
                        ]),
                        _createVNode("div", _hoisted_31, [
                          (_ctx.state.ui.showUI.counter && !_ctx.state.ui.showUI.resendPrimaryOTP && _ctx.state.data.setCounter)
                            ? (_openBlock(), _createBlock(_component_CounterComponent, {
                                key: 0,
                                onUpdateStatus: _ctx.handleStatusUpdateForPrimary,
                                initialTime: _ctx.state.data.setCounter
                              }, null, 8, ["onUpdateStatus", "initialTime"]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.state.ui.showUI.showOTP)
          ? (_openBlock(), _createBlock("div", _hoisted_32, [
              _createVNode("div", _hoisted_33, [
                (!_ctx.state.data.isPrimaryEmail)
                  ? (_openBlock(), _createBlock("p", _hoisted_34, [
                      _hoisted_35,
                      _hoisted_36,
                      _createVNode("strong", null, _toDisplayString(_ctx.enteredValue), 1),
                      _hoisted_37
                    ]))
                  : (_openBlock(), _createBlock("p", _hoisted_38, [
                      _hoisted_39,
                      _hoisted_40,
                      _createVNode("strong", null, _toDisplayString(_ctx.enteredValue), 1),
                      _hoisted_41
                    ]))
              ]),
              (_ctx.state.ui.showUI.resendPrimaryOTP)
                ? (_openBlock(), _createBlock("div", _hoisted_42, [
                    _createVNode("p", _hoisted_43, [
                      _hoisted_44,
                      _createVNode("a", {
                        href: "javascript:void(0)",
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.verifyAgainPrimary && _ctx.verifyAgainPrimary(...args)))
                      }, [
                        _hoisted_45
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.state.ui.showUI.notificationBy)
          ? (_openBlock(), _createBlock("div", _hoisted_46, [
              _createVNode("div", _hoisted_47, [
                _hoisted_48,
                _createVNode("div", _hoisted_49, [
                  _createVNode("div", _hoisted_50, [
                    _createVNode("div", _hoisted_51, [
                      _withDirectives(_createVNode("input", {
                        class: "form-check-input",
                        disabled: _ctx.state.ui.disabled.disableSmsCheckbox,
                        type: "checkbox",
                        id: "flexCheckDefault",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.state.data.registration.notification.sms = $event)),
                        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.checkNotificationSms && _ctx.checkNotificationSms(...args)))
                      }, null, 8, ["disabled"]), [
                        [_vModelCheckbox, _ctx.state.data.registration.notification.sms]
                      ]),
                      _hoisted_52
                    ])
                  ]),
                  _createVNode("div", _hoisted_53, [
                    _createVNode("div", _hoisted_54, [
                      _withDirectives(_createVNode("input", {
                        class: "form-check-input",
                        disabled: _ctx.state.ui.disabled.disableEmailCheckbox,
                        type: "checkbox",
                        id: "flexCheckDefault1",
                        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.checkNotificationEmail && _ctx.checkNotificationEmail(...args))),
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.state.data.registration.notification.email = $event))
                      }, null, 8, ["disabled"]), [
                        [_vModelCheckbox, _ctx.state.data.registration.notification.email]
                      ]),
                      _hoisted_55
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        ((_ctx.state.ui.showUI.showEmailInput) || (_ctx.state.ui.showUI.showMobileNumber))
          ? (_openBlock(), _createBlock("div", _hoisted_56, [
              _createVNode("label", _hoisted_57, _toDisplayString(_ctx.state.ui.showUI.showEmailInput ? 'Email' : 'Mobile Number') + ":", 1),
              _createVNode("div", _hoisted_58, [
                _createVNode("div", {
                  class: _ctx.state.ui.showUI.secondaryInputClass
                }, [
                  _createVNode("div", _hoisted_59, [
                    (_ctx.state.ui.showUI.showEmailInput)
                      ? (_openBlock(), _createBlock(_component_AppEmailInput, {
                          key: 0,
                          disabled: _ctx.state.ui.disabled.secondary,
                          onValidEmail: _ctx.handleValidEmail,
                          onError: _ctx.handleEmailError,
                          onClearError: _ctx.clearError,
                          onValidationStatus: _ctx.handleSecondaryValidationResult
                        }, null, 8, ["disabled", "onValidEmail", "onError", "onClearError", "onValidationStatus"]))
                      : _createCommentVNode("", true),
                    (_ctx.state.ui.showUI.showMobileNumber)
                      ? (_openBlock(), _createBlock(_component_AppPhoneNumberInput, {
                          key: 1,
                          disabled: _ctx.state.ui.disabled.secondary,
                          modelValue: _ctx.enteredSecondaryValue,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.enteredSecondaryValue = $event)),
                          onValidationStatus: _ctx.handleSecondaryValidationResult,
                          onErrorMessage: _ctx.handleEmailError
                        }, null, 8, ["disabled", "modelValue", "onValidationStatus", "onErrorMessage"]))
                      : _createCommentVNode("", true),
                    (_ctx.state.ui.showUI.changeSecondaryInput)
                      ? (_openBlock(), _createBlock("div", _hoisted_60, [
                          _createVNode("a", {
                            title: "edit",
                            href: "javascript:void(0)",
                            class: "change-text",
                            onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.dataSecondaryClear && _ctx.dataSecondaryClear(...args)))
                          }, [
                            _hoisted_61,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('change')), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ], 2),
                (!_ctx.state.ui.showUI.secondaryOTPSent)
                  ? (_openBlock(), _createBlock("div", {
                      key: 0,
                      class: _ctx.state.ui.showUI.secondaryIconClass
                    }, [
                      (_ctx.state.ui.showUI.secondaryVerifiedOTP)
                        ? (_openBlock(), _createBlock("div", _hoisted_62, [
                            _hoisted_63
                          ]))
                        : (_openBlock(), _createBlock("button", {
                            key: 1,
                            disabled: (!_ctx.buttonhasValidSecondaryInput) || (_ctx.state.ui.showUI.secondaryVerifiedOTP),
                            class: "btn default-btn w-100 h-100",
                            onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.verifySecondary && _ctx.verifySecondary(...args)))
                          }, _toDisplayString(_ctx.$t('verify')), 9, ["disabled"]))
                    ], 2))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.state.data.secondaryErrorMessage)
                ? (_openBlock(), _createBlock("div", _hoisted_64, [
                    _createVNode("p", _hoisted_65, _toDisplayString(_ctx.state.data.secondaryErrorMessage), 1)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.state.ui.showUI.showSecondaryOTP)
          ? (_openBlock(), _createBlock("div", _hoisted_66, [
              _hoisted_67,
              _createVNode("div", _hoisted_68, [
                _hoisted_69,
                _createVNode("div", _hoisted_70, [
                  _createVNode("div", _hoisted_71, [
                    _createVNode("div", _hoisted_72, [
                      _createVNode("div", _hoisted_73, [
                        _createVNode("div", _hoisted_74, [
                          _createVNode(_component_AppOTPInput, { onSixDigitInput: _ctx.handleSixDigitOTPSeonndary }, null, 8, ["onSixDigitInput"])
                        ]),
                        _createVNode("div", _hoisted_75, [
                          (_ctx.state.ui.showUI.counterSecondary && !_ctx.state.ui.showUI.resendSecondaryOTP && _ctx.state.data.setSecondaryCounter)
                            ? (_openBlock(), _createBlock(_component_CounterComponent, {
                                key: 0,
                                onUpdateStatus: _ctx.handleStatusUpdateForSecondary,
                                initialTime: _ctx.state.data.setSecondaryCounter
                              }, null, 8, ["onUpdateStatus", "initialTime"]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.state.ui.showUI.showSecondaryOTP)
          ? (_openBlock(), _createBlock("div", _hoisted_76, [
              _createVNode("div", _hoisted_77, [
                (!_ctx.state.data.isSecondaryEmail)
                  ? (_openBlock(), _createBlock("p", _hoisted_78, [
                      _hoisted_79,
                      _hoisted_80,
                      _createVNode("strong", null, _toDisplayString(_ctx.enteredSecondaryValue), 1),
                      _hoisted_81
                    ]))
                  : (_openBlock(), _createBlock("p", _hoisted_82, [
                      _hoisted_83,
                      _hoisted_84,
                      _createVNode("strong", null, _toDisplayString(_ctx.enteredSecondaryValue), 1),
                      _hoisted_85
                    ]))
              ]),
              (_ctx.state.ui.showUI.resendSecondaryOTP)
                ? (_openBlock(), _createBlock("div", _hoisted_86, [
                    _createVNode("p", _hoisted_87, [
                      _hoisted_88,
                      _createVNode("a", {
                        href: "javascript:void(0)",
                        onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.verifyAgainSecondary && _ctx.verifyAgainSecondary(...args)))
                      }, [
                        _hoisted_89
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_90, [
          _createVNode("a", {
            class: "btn d-block button-gradient",
            onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.register && _ctx.register(...args)))
          }, "Sign Up")
        ])
      ])
    ]),
    _createVNode("div", _hoisted_91, [
      _createVNode("div", _hoisted_92, [
        _createVNode("div", _hoisted_93, [
          _createVNode("div", _hoisted_94, [
            _createVNode("div", _hoisted_95, [
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.hideRegisterSuccessModal && _ctx.hideRegisterSuccessModal(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_96
              ]),
              _hoisted_97
            ]),
            _createVNode("div", _hoisted_98, [
              _createVNode("div", _hoisted_99, [
                _createVNode("img", {
                  src: _ctx.state.data.imageBaseUrl
                ? `${_ctx.state.data.imageBaseUrl}img/checked.jpg`
                : 'img/checked.jpg'
                ,
                  alt: ""
                }, null, 8, ["src"]),
                _hoisted_100
              ])
            ]),
            _createVNode("div", _hoisted_101, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn w-100",
                onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.hideRegisterSuccessModal && _ctx.hideRegisterSuccessModal(...args)))
              }, " Continue ")
            ])
          ])
        ])
      ])
    ])
  ], 64))
}